module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_m_leucistic.02da1372.png";